<div class="mute-dialog" id="ClaimAlertDialog">
    <div class="mute-dialog-header">
        <div class="mute-dialog-title">Claim this alert</div>
        <div class="mute-dialog-subtitle">
            A claim says you are looking at this alert. It does not stop the notifications: the alert still fires, still
            expires, and still resolves on its own. To stop the notifications, create a mute instead.
        </div>
    </div>

    <div class="mute-dialog-summary" id="ClaimSummary">
        <span class="mute-dialog-summary-label">You are taking</span>
        <span>{{ alertSummary }}</span>
    </div>

    <div class="mute-dialog-section">
        <div class="mute-dialog-label">Note <span class="mute-dialog-optional">optional</span></div>
        <!-- Worth writing, but never a gate: this is what the next reader sees on the row
             and in the drawer, and it is the answer to "somebody has this — doing what?".
             Taking an alert during an incident still goes through without it. -->
        <textarea
            class="mute-reason"
            id="ClaimNote"
            rows="2"
            maxlength="500"
            placeholder="e.g. looking at the router now, replacement on order"
            [(ngModel)]="note"
        ></textarea>
    </div>

    <div class="mute-dialog-actions">
        <button type="button" class="mute-button mute-button-cancel" id="ClaimCancel" (click)="cancel()">Cancel</button>
        <button type="button" class="mute-button" id="ClaimConfirm" (click)="confirm()">Claim</button>
    </div>
</div>
